module.exports = __webpack_public_path__ + "img/vccl.4113aca4.svg";